export const queryStatus = {
  created: "created",
  approved: "approved",
  processing: "processing",
  active: "active",
  updated: "updated",
  deleted: "deleted",
  rejected: "rejected"
}
